import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const BADGES = [
  { img: "/trustmarks/partner.webp", title: "GCSB Accredited Partner", id: "GCSB-AP-2026-004" },
  { img: "/trustmarks/coe.webp", title: "GCSB Centre of Excellence", id: "GCSB-AP-2026-002" },
];

const TRAINING = [["CSCE", "GCSB-AP-2026-005"], ["CSP", "GCSB-AP-2026-006"], ["CSL", "GCSB-AP-2026-007"], ["CCSO", "GCSB-AP-2026-008"], ["PGDCSL", "GCSB-AP-2026-009"]];
const VERIFY = "https://gcsb.uk/verify";

export const TrustBadgesStrip = ({ className = "", compact = false }) => (
  <section className={className} data-testid="trust-badges-strip">
    <div className={`rounded-3xl border border-[var(--border-warm)] bg-[var(--navy-deep)] text-white ${compact ? "p-4" : "p-5 sm:p-6"} flex flex-wrap items-center gap-4 sm:gap-6`}>
      <div className={`min-w-0 ${compact ? "basis-full" : "flex-1 min-w-[220px]"}`}>
        <div className="eyebrow !text-[var(--gold-soft)]">Independently accredited</div>
        <div className={`font-display leading-tight mt-1 ${compact ? "text-lg" : "text-xl sm:text-2xl"}`}>CSI is accredited by the Global Converged Security Board</div>
      </div>
      <div className="flex flex-wrap items-center gap-4">
        {BADGES.map((b) => (
          <div key={b.id} className="flex items-center gap-3 group" data-testid={`trust-badge-${b.id}`}>
            <Link to="/accreditation" title={b.title}>
              <img src={b.img} alt={b.title} loading="lazy" className={`${compact ? "w-14 h-14" : "w-16 h-16 sm:w-20 sm:h-20"} rounded-full group-hover:scale-105 transition-transform`}/>
            </Link>
            <div className="text-xs leading-snug">
              <Link to="/accreditation" className="font-semibold hover:underline block">{b.title}</Link>
              <a href={VERIFY} target="_blank" rel="noopener noreferrer" className="text-zinc-400 hover:text-[var(--gold-soft)] font-mono text-[10px] underline" title="Verify at gcsb.uk/verify" data-testid={`trust-verify-${b.id}`}>{b.id}</a>
            </div>
          </div>
        ))}
      </div>
      {!compact && (
        <div className="basis-full text-[11px] text-zinc-300 flex flex-wrap items-center gap-x-3 gap-y-1" data-testid="trust-training-partner">
          <span className="font-semibold text-white">GCSB Training Partner:</span>
          {TRAINING.map(([q, id]) => (
            <a key={id} href={VERIFY} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--gold-soft)]" title="Verify at gcsb.uk/verify" data-testid={`trust-verify-${id}`}>
              {q} <span className="font-mono underline">{id}</span>
            </a>
          ))}
        </div>
      )}
      {!compact && (
        <Link to="/accreditation" className="chip bg-white/5 border-white/20 text-white hover:bg-white/10 inline-flex items-center gap-1.5 text-xs" data-testid="trust-badges-more">
          All accreditations <ArrowRight size={13}/>
        </Link>
      )}
    </div>
  </section>
);
